var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHint = function SvgHint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "*{vector-effect:non-scaling-stroke}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.426 14.627h2.666c0-1.713 3.27-2.57 3.27-5.488 0-2.51-2.16-3.834-4.34-3.834-2.53 0-4.768 1.42-4.768 4.398H9.92c0-1.187.818-1.79 2.005-1.79 1.128 0 1.77.525 1.77 1.42 0 1.927-3.269 2.725-3.269 5.294m-.058 4.573h2.783v-2.783h-2.783z"
  })));
};
export default SvgHint;